import React, { useContext, useEffect, useRef, useState } from 'react'
import './SHPaymentCard.css'
import Dropdown from '../../../../components/Dropdown/Dropdown';
import CustomPhoneSelect from '../../../../components/CustomPhoneSelect/CustomPhoneSelect';
import countryCodes from '../../../CustomPlan/countryCodes.json'
import paymentImg from '../../../../assets/payment-img.png'
import { GeneralContext } from '../../../../GeneralProvider';
import Services from '../../../../services/Services';
import { useToaster } from '../../../../ToasterProvider';
import axios from 'axios';
import { useLanguage } from '../../../../LanguageProvider';

export default function SHPaymentCard({ payPrice, items, setActiveTab }) {
    const { getTranslation } = useLanguage();

    const { toastError, toastSuccess } = useToaster();
    const token = localStorage.getItem("token")
    const intervalRef = useRef(null);
    const { userId } = useContext(GeneralContext);
    const [name, setName] = useState("");
    const [expiry, setExpiry] = useState("");
    const [cardNumber, setCardNumber] = useState("");
    const [cvv, setCvv] = useState("");
    const [address, setAddress] = useState("");
    const [countryCode, setCountryCode] = useState("+90");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [city, setCity] = useState("");
    const [selectedCountry, setSelectedCountry] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [taxNo, setTaxNo] = useState("");
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [tckn, setTckn] = useState("");

    const [htmlContent, setHtmlContent] = useState("");
    const [show3DSModal, setShow3DSModal] = useState(false);
    const [paymentID, setPaymentID] = useState("");

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [userCountry, setUserCountry] = useState("");


    useEffect(() => {
        axios.get('https://api.ipify.org?format=json')
            .then(res => {
                const userIP = res.data.ip;
                return axios.get(`https://api.ipdata.co/${userIP}?api-key=e079e8cc30eccf8ecde4af4981b90f6cb44d46b3b095fdb921fcea6c`);
            })
            .then(res => {
                setUserCountry(res.data.country_name)
            })
            .catch(err => console.error(err));
    }, []);

    const countries = [
        {
            "value": "Aruba",
            "label": "Aruba"
        },
        {
            "value": "Afghanistan",
            "label": "Afghanistan"
        },
        {
            "value": "Angola",
            "label": "Angola"
        },
        {
            "value": "Anguilla",
            "label": "Anguilla"
        },
        {
            "value": "\u00c5land Islands",
            "label": "\u00c5land Islands"
        },
        {
            "value": "Albania",
            "label": "Albania"
        },
        {
            "value": "Andorra",
            "label": "Andorra"
        },
        {
            "value": "United Arab Emirates",
            "label": "United Arab Emirates"
        },
        {
            "value": "Argentina",
            "label": "Argentina"
        },
        {
            "value": "Armenia",
            "label": "Armenia"
        },
        {
            "value": "American Samoa",
            "label": "American Samoa"
        },
        {
            "value": "Antarctica",
            "label": "Antarctica"
        },
        {
            "value": "French Southern Territories",
            "label": "French Southern Territories"
        },
        {
            "value": "Antigua and Barbuda",
            "label": "Antigua and Barbuda"
        },
        {
            "value": "Australia",
            "label": "Australia"
        },
        {
            "value": "Austria",
            "label": "Austria"
        },
        {
            "value": "Azerbaijan",
            "label": "Azerbaijan"
        },
        {
            "value": "Burundi",
            "label": "Burundi"
        },
        {
            "value": "Belgium",
            "label": "Belgium"
        },
        {
            "value": "Benin",
            "label": "Benin"
        },
        {
            "value": "Bonaire, Sint Eustatius and Saba",
            "label": "Bonaire, Sint Eustatius and Saba"
        },
        {
            "value": "Burkina Faso",
            "label": "Burkina Faso"
        },
        {
            "value": "Bangladesh",
            "label": "Bangladesh"
        },
        {
            "value": "Bulgaria",
            "label": "Bulgaria"
        },
        {
            "value": "Bahrain",
            "label": "Bahrain"
        },
        {
            "value": "Bahamas",
            "label": "Bahamas"
        },
        {
            "value": "Bosnia and Herzegovina",
            "label": "Bosnia and Herzegovina"
        },
        {
            "value": "Saint Barth\u00e9lemy",
            "label": "Saint Barth\u00e9lemy"
        },
        {
            "value": "Belarus",
            "label": "Belarus"
        },
        {
            "value": "Belize",
            "label": "Belize"
        },
        {
            "value": "Bermuda",
            "label": "Bermuda"
        },
        {
            "value": "Bolivia, Plurinational State of",
            "label": "Bolivia, Plurinational State of"
        },
        {
            "value": "Brazil",
            "label": "Brazil"
        },
        {
            "value": "Barbados",
            "label": "Barbados"
        },
        {
            "value": "Brunei Darussalam",
            "label": "Brunei Darussalam"
        },
        {
            "value": "Bhutan",
            "label": "Bhutan"
        },
        {
            "value": "Bouvet Island",
            "label": "Bouvet Island"
        },
        {
            "value": "Botswana",
            "label": "Botswana"
        },
        {
            "value": "Central African Republic",
            "label": "Central African Republic"
        },
        {
            "value": "Canada",
            "label": "Canada"
        },
        {
            "value": "Cocos (Keeling) Islands",
            "label": "Cocos (Keeling) Islands"
        },
        {
            "value": "Switzerland",
            "label": "Switzerland"
        },
        {
            "value": "Chile",
            "label": "Chile"
        },
        {
            "value": "China",
            "label": "China"
        },
        {
            "value": "C\u00f4te d'Ivoire",
            "label": "C\u00f4te d'Ivoire"
        },
        {
            "value": "Cameroon",
            "label": "Cameroon"
        },
        {
            "value": "Congo, The Democratic Republic of the",
            "label": "Congo, The Democratic Republic of the"
        },
        {
            "value": "Congo",
            "label": "Congo"
        },
        {
            "value": "Cook Islands",
            "label": "Cook Islands"
        },
        {
            "value": "Colombia",
            "label": "Colombia"
        },
        {
            "value": "Comoros",
            "label": "Comoros"
        },
        {
            "value": "Cabo Verde",
            "label": "Cabo Verde"
        },
        {
            "value": "Costa Rica",
            "label": "Costa Rica"
        },
        {
            "value": "Cuba",
            "label": "Cuba"
        },
        {
            "value": "Cura\u00e7ao",
            "label": "Cura\u00e7ao"
        },
        {
            "value": "Christmas Island",
            "label": "Christmas Island"
        },
        {
            "value": "Cayman Islands",
            "label": "Cayman Islands"
        },
        {
            "value": "Cyprus",
            "label": "Cyprus"
        },
        {
            "value": "Czechia",
            "label": "Czechia"
        },
        {
            "value": "Germany",
            "label": "Germany"
        },
        {
            "value": "Djibouti",
            "label": "Djibouti"
        },
        {
            "value": "Dominica",
            "label": "Dominica"
        },
        {
            "value": "Denmark",
            "label": "Denmark"
        },
        {
            "value": "Dominican Republic",
            "label": "Dominican Republic"
        },
        {
            "value": "Algeria",
            "label": "Algeria"
        },
        {
            "value": "Ecuador",
            "label": "Ecuador"
        },
        {
            "value": "Egypt",
            "label": "Egypt"
        },
        {
            "value": "Eritrea",
            "label": "Eritrea"
        },
        {
            "value": "Western Sahara",
            "label": "Western Sahara"
        },
        {
            "value": "Spain",
            "label": "Spain"
        },
        {
            "value": "Estonia",
            "label": "Estonia"
        },
        {
            "value": "Ethiopia",
            "label": "Ethiopia"
        },
        {
            "value": "Finland",
            "label": "Finland"
        },
        {
            "value": "Fiji",
            "label": "Fiji"
        },
        {
            "value": "Falkland Islands (Malvinas)",
            "label": "Falkland Islands (Malvinas)"
        },
        {
            "value": "France",
            "label": "France"
        },
        {
            "value": "Faroe Islands",
            "label": "Faroe Islands"
        },
        {
            "value": "Micronesia, Federated States of",
            "label": "Micronesia, Federated States of"
        },
        {
            "value": "Gabon",
            "label": "Gabon"
        },
        {
            "value": "United Kingdom",
            "label": "United Kingdom"
        },
        {
            "value": "Georgia",
            "label": "Georgia"
        },
        {
            "value": "Guernsey",
            "label": "Guernsey"
        },
        {
            "value": "Ghana",
            "label": "Ghana"
        },
        {
            "value": "Gibraltar",
            "label": "Gibraltar"
        },
        {
            "value": "Guinea",
            "label": "Guinea"
        },
        {
            "value": "Guadeloupe",
            "label": "Guadeloupe"
        },
        {
            "value": "Gambia",
            "label": "Gambia"
        },
        {
            "value": "Guinea-Bissau",
            "label": "Guinea-Bissau"
        },
        {
            "value": "Equatorial Guinea",
            "label": "Equatorial Guinea"
        },
        {
            "value": "Greece",
            "label": "Greece"
        },
        {
            "value": "Grenada",
            "label": "Grenada"
        },
        {
            "value": "Greenland",
            "label": "Greenland"
        },
        {
            "value": "Guatemala",
            "label": "Guatemala"
        },
        {
            "value": "French Guiana",
            "label": "French Guiana"
        },
        {
            "value": "Guam",
            "label": "Guam"
        },
        {
            "value": "Guyana",
            "label": "Guyana"
        },
        {
            "value": "Hong Kong",
            "label": "Hong Kong"
        },
        {
            "value": "Heard Island and McDonald Islands",
            "label": "Heard Island and McDonald Islands"
        },
        {
            "value": "Honduras",
            "label": "Honduras"
        },
        {
            "value": "Croatia",
            "label": "Croatia"
        },
        {
            "value": "Haiti",
            "label": "Haiti"
        },
        {
            "value": "Hungary",
            "label": "Hungary"
        },
        {
            "value": "Indonesia",
            "label": "Indonesia"
        },
        {
            "value": "Isle of Man",
            "label": "Isle of Man"
        },
        {
            "value": "India",
            "label": "India"
        },
        {
            "value": "British Indian Ocean Territory",
            "label": "British Indian Ocean Territory"
        },
        {
            "value": "Ireland",
            "label": "Ireland"
        },
        {
            "value": "Iran, Islamic Republic of",
            "label": "Iran, Islamic Republic of"
        },
        {
            "value": "Iraq",
            "label": "Iraq"
        },
        {
            "value": "Iceland",
            "label": "Iceland"
        },
        {
            "value": "Israel",
            "label": "Israel"
        },
        {
            "value": "Italy",
            "label": "Italy"
        },
        {
            "value": "Jamaica",
            "label": "Jamaica"
        },
        {
            "value": "Jersey",
            "label": "Jersey"
        },
        {
            "value": "Jordan",
            "label": "Jordan"
        },
        {
            "value": "Japan",
            "label": "Japan"
        },
        {
            "value": "Kazakhstan",
            "label": "Kazakhstan"
        },
        {
            "value": "Kenya",
            "label": "Kenya"
        },
        {
            "value": "Kyrgyzstan",
            "label": "Kyrgyzstan"
        },
        {
            "value": "Cambodia",
            "label": "Cambodia"
        },
        {
            "value": "Kiribati",
            "label": "Kiribati"
        },
        {
            "value": "Saint Kitts and Nevis",
            "label": "Saint Kitts and Nevis"
        },
        {
            "value": "Korea, Republic of",
            "label": "Korea, Republic of"
        },
        {
            "value": "Kuwait",
            "label": "Kuwait"
        },
        {
            "value": "Lao People's Democratic Republic",
            "label": "Lao People's Democratic Republic"
        },
        {
            "value": "Lebanon",
            "label": "Lebanon"
        },
        {
            "value": "Liberia",
            "label": "Liberia"
        },
        {
            "value": "Libya",
            "label": "Libya"
        },
        {
            "value": "Saint Lucia",
            "label": "Saint Lucia"
        },
        {
            "value": "Liechtenstein",
            "label": "Liechtenstein"
        },
        {
            "value": "Sri Lanka",
            "label": "Sri Lanka"
        },
        {
            "value": "Lesotho",
            "label": "Lesotho"
        },
        {
            "value": "Lithuania",
            "label": "Lithuania"
        },
        {
            "value": "Luxembourg",
            "label": "Luxembourg"
        },
        {
            "value": "Latvia",
            "label": "Latvia"
        },
        {
            "value": "Macao",
            "label": "Macao"
        },
        {
            "value": "Saint Martin (French part)",
            "label": "Saint Martin (French part)"
        },
        {
            "value": "Morocco",
            "label": "Morocco"
        },
        {
            "value": "Monaco",
            "label": "Monaco"
        },
        {
            "value": "Moldova, Republic of",
            "label": "Moldova, Republic of"
        },
        {
            "value": "Madagascar",
            "label": "Madagascar"
        },
        {
            "value": "Maldives",
            "label": "Maldives"
        },
        {
            "value": "Mexico",
            "label": "Mexico"
        },
        {
            "value": "Marshall Islands",
            "label": "Marshall Islands"
        },
        {
            "value": "North Macedonia",
            "label": "North Macedonia"
        },
        {
            "value": "Mali",
            "label": "Mali"
        },
        {
            "value": "Malta",
            "label": "Malta"
        },
        {
            "value": "Myanmar",
            "label": "Myanmar"
        },
        {
            "value": "Montenegro",
            "label": "Montenegro"
        },
        {
            "value": "Mongolia",
            "label": "Mongolia"
        },
        {
            "value": "Northern Mariana Islands",
            "label": "Northern Mariana Islands"
        },
        {
            "value": "Mozambique",
            "label": "Mozambique"
        },
        {
            "value": "Mauritania",
            "label": "Mauritania"
        },
        {
            "value": "Montserrat",
            "label": "Montserrat"
        },
        {
            "value": "Martinique",
            "label": "Martinique"
        },
        {
            "value": "Mauritius",
            "label": "Mauritius"
        },
        {
            "value": "Malawi",
            "label": "Malawi"
        },
        {
            "value": "Malaysia",
            "label": "Malaysia"
        },
        {
            "value": "Mayotte",
            "label": "Mayotte"
        },
        {
            "value": "Namibia",
            "label": "Namibia"
        },
        {
            "value": "New Caledonia",
            "label": "New Caledonia"
        },
        {
            "value": "Niger",
            "label": "Niger"
        },
        {
            "value": "Norfolk Island",
            "label": "Norfolk Island"
        },
        {
            "value": "Nigeria",
            "label": "Nigeria"
        },
        {
            "value": "Nicaragua",
            "label": "Nicaragua"
        },
        {
            "value": "Niue",
            "label": "Niue"
        },
        {
            "value": "Netherlands",
            "label": "Netherlands"
        },
        {
            "value": "Norway",
            "label": "Norway"
        },
        {
            "value": "Nepal",
            "label": "Nepal"
        },
        {
            "value": "Nauru",
            "label": "Nauru"
        },
        {
            "value": "New Zealand",
            "label": "New Zealand"
        },
        {
            "value": "Oman",
            "label": "Oman"
        },
        {
            "value": "Pakistan",
            "label": "Pakistan"
        },
        {
            "value": "Panama",
            "label": "Panama"
        },
        {
            "value": "Pitcairn",
            "label": "Pitcairn"
        },
        {
            "value": "Peru",
            "label": "Peru"
        },
        {
            "value": "Philippines",
            "label": "Philippines"
        },
        {
            "value": "Palau",
            "label": "Palau"
        },
        {
            "value": "Papua New Guinea",
            "label": "Papua New Guinea"
        },
        {
            "value": "Poland",
            "label": "Poland"
        },
        {
            "value": "Puerto Rico",
            "label": "Puerto Rico"
        },
        {
            "value": "Korea, Democratic People's Republic of",
            "label": "Korea, Democratic People's Republic of"
        },
        {
            "value": "Portugal",
            "label": "Portugal"
        },
        {
            "value": "Paraguay",
            "label": "Paraguay"
        },
        {
            "value": "Palestine, State of",
            "label": "Palestine, State of"
        },
        {
            "value": "French Polynesia",
            "label": "French Polynesia"
        },
        {
            "value": "Qatar",
            "label": "Qatar"
        },
        {
            "value": "R\u00e9union",
            "label": "R\u00e9union"
        },
        {
            "value": "Romania",
            "label": "Romania"
        },
        {
            "value": "Russian Federation",
            "label": "Russian Federation"
        },
        {
            "value": "Rwanda",
            "label": "Rwanda"
        },
        {
            "value": "Saudi Arabia",
            "label": "Saudi Arabia"
        },
        {
            "value": "Sudan",
            "label": "Sudan"
        },
        {
            "value": "Senegal",
            "label": "Senegal"
        },
        {
            "value": "Singapore",
            "label": "Singapore"
        },
        {
            "value": "South Georgia and the South Sandwich Islands",
            "label": "South Georgia and the South Sandwich Islands"
        },
        {
            "value": "Saint Helena, Ascension and Tristan da Cunha",
            "label": "Saint Helena, Ascension and Tristan da Cunha"
        },
        {
            "value": "Svalbard and Jan Mayen",
            "label": "Svalbard and Jan Mayen"
        },
        {
            "value": "Solomon Islands",
            "label": "Solomon Islands"
        },
        {
            "value": "Sierra Leone",
            "label": "Sierra Leone"
        },
        {
            "value": "El Salvador",
            "label": "El Salvador"
        },
        {
            "value": "San Marino",
            "label": "San Marino"
        },
        {
            "value": "Somalia",
            "label": "Somalia"
        },
        {
            "value": "Saint Pierre and Miquelon",
            "label": "Saint Pierre and Miquelon"
        },
        {
            "value": "Serbia",
            "label": "Serbia"
        },
        {
            "value": "South Sudan",
            "label": "South Sudan"
        },
        {
            "value": "Sao Tome and Principe",
            "label": "Sao Tome and Principe"
        },
        {
            "value": "Suriname",
            "label": "Suriname"
        },
        {
            "value": "Slovakia",
            "label": "Slovakia"
        },
        {
            "value": "Slovenia",
            "label": "Slovenia"
        },
        {
            "value": "Sweden",
            "label": "Sweden"
        },
        {
            "value": "Eswatini",
            "label": "Eswatini"
        },
        {
            "value": "Sint Maarten (Dutch part)",
            "label": "Sint Maarten (Dutch part)"
        },
        {
            "value": "Seychelles",
            "label": "Seychelles"
        },
        {
            "value": "Syrian Arab Republic",
            "label": "Syrian Arab Republic"
        },
        {
            "value": "Turks and Caicos Islands",
            "label": "Turks and Caicos Islands"
        },
        {
            "value": "Chad",
            "label": "Chad"
        },
        {
            "value": "Togo",
            "label": "Togo"
        },
        {
            "value": "Thailand",
            "label": "Thailand"
        },
        {
            "value": "Tajikistan",
            "label": "Tajikistan"
        },
        {
            "value": "Tokelau",
            "label": "Tokelau"
        },
        {
            "value": "Turkmenistan",
            "label": "Turkmenistan"
        },
        {
            "value": "Timor-Leste",
            "label": "Timor-Leste"
        },
        {
            "value": "Tonga",
            "label": "Tonga"
        },
        {
            "value": "Trinidad and Tobago",
            "label": "Trinidad and Tobago"
        },
        {
            "value": "Tunisia",
            "label": "Tunisia"
        },
        {
            "value": "Türkiye",
            "label": "Türkiye"
        },
        {
            "value": "Tuvalu",
            "label": "Tuvalu"
        },
        {
            "value": "Taiwan, Province of China",
            "label": "Taiwan, Province of China"
        },
        {
            "value": "Tanzania, United Republic of",
            "label": "Tanzania, United Republic of"
        },
        {
            "value": "Uganda",
            "label": "Uganda"
        },
        {
            "value": "Ukraine",
            "label": "Ukraine"
        },
        {
            "value": "United States Minor Outlying Islands",
            "label": "United States Minor Outlying Islands"
        },
        {
            "value": "Uruguay",
            "label": "Uruguay"
        },
        {
            "value": "United States",
            "label": "United States"
        },
        {
            "value": "Uzbekistan",
            "label": "Uzbekistan"
        },
        {
            "value": "Holy See (Vatican City State)",
            "label": "Holy See (Vatican City State)"
        },
        {
            "value": "Saint Vincent and the Grenadines",
            "label": "Saint Vincent and the Grenadines"
        },
        {
            "value": "Venezuela, Bolivarian Republic of",
            "label": "Venezuela, Bolivarian Republic of"
        },
        {
            "value": "Virgin Islands, British",
            "label": "Virgin Islands, British"
        },
        {
            "value": "Virgin Islands, U.S.",
            "label": "Virgin Islands, U.S."
        },
        {
            "value": "Viet Nam",
            "label": "Viet Nam"
        },
        {
            "value": "Vanuatu",
            "label": "Vanuatu"
        },
        {
            "value": "Wallis and Futuna",
            "label": "Wallis and Futuna"
        },
        {
            "value": "Samoa",
            "label": "Samoa"
        },
        {
            "value": "Yemen",
            "label": "Yemen"
        },
        {
            "value": "South Africa",
            "label": "South Africa"
        },
        {
            "value": "Zambia",
            "label": "Zambia"
        },
        {
            "value": "Zimbabwe",
            "label": "Zimbabwe"
        }
    ];

    useEffect(() => {
        if (show3DSModal && paymentID) {
            intervalRef.current = setInterval(() => {
                Services.ListenSHPayment(paymentID)
                    .then(res => {
                        const status = res.data?.status;
                        if (status === "1" || status === "2") {
                            if (status === "1") {
                                toastSuccess(getTranslation('paymentCompleted'));
                                const soldTickets = Object.values(items).flat();
                                const billing = {
                                    tckn,
                                    address,
                                    city,
                                    region: selectedCountry,
                                    postalCode
                                };


                                soldTickets.forEach(ticket => {
                                    Services.SocialHiveCreateSoldTicket(
                                        token,
                                        ticket.channelID,
                                        ticket.eventID,
                                        ticket.ticketID,
                                        ticket.ticketPrice === 0 ? "free" : paymentID,
                                        ticket.name,
                                        ticket.lastname,
                                        ticket.email,
                                        ticket.phone,
                                        true,
                                        billing
                                    )
                                        .then(response => {
                                            setActiveTab(getTranslation('details'))
                                        })
                                        .catch(err => {
                                            console.error("CreateSoldTicket error", err);
                                        });
                                });

                                setShow3DSModal(false);
                                setHtmlContent("");
                                clearInterval(intervalRef.current);
                            }
                            else {
                                setShow3DSModal(false);
                                setHtmlContent("");
                                clearInterval(intervalRef.current);
                                toastError(getTranslation('paymentFailed'));
                            }
                        }
                        else if (status !== "5") {
                            setShow3DSModal(false);
                            setHtmlContent("");
                            clearInterval(intervalRef.current);
                            toastError(getTranslation('paymentFailed'));
                        }
                    })
                    .catch(err => {
                        console.error("ListenPayment Error", err);
                    });
            }, 1000);
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [show3DSModal, paymentID]);

    const handleExpiryChange = (e) => {
        let input = e.target.value.replace(/\D/g, ""); // sadece rakamlar

        // Ay kısmını düzenle
        if (input.length >= 2) {
            let inputMonth = parseInt(input.slice(0, 2), 10);
            if (inputMonth > 12) inputMonth = 12;

            const formattedMonth = inputMonth.toString().padStart(2, "0");
            const inputYear = input.slice(2, 6);

            setMonth(formattedMonth);
            setYear(inputYear);

            const combined = inputYear ? `${formattedMonth}/${inputYear}` : formattedMonth;
            setExpiry(combined);
        } else {
            setMonth(input);
            setYear("");
            setExpiry(input);
        }
    };

    function splitFullName(fullName) {
        if (!fullName || typeof fullName !== 'string') {
            return { firstName: '', lastName: '' };
        }

        const parts = fullName.trim().split(/\s+/);

        if (parts.length === 1) {
            return {
                firstName: parts[0],
                lastName: ''
            };
        }

        return {
            firstName: parts.slice(0, -1).join(' '), // Tüm isimler
            lastName: parts[parts.length - 1]        // Son kelime soyisim
        };
    }


    const handleCompletePayment = () => {

        const { firstName, lastName } = splitFullName(name);
        const gsmNumber = countryCode + phone
        const price = payPrice
        const currency = userCountry === "TL"
        const identityNo = tckn ? tckn : userCountry === "Turkey" ? "11111111111" : "22222222222"

        setIsButtonDisabled(true)

        const formattedItems = Object.values(items)
            .flat()
            .filter(({ ticketPrice }) => ticketPrice !== 0)
            .map(({ ticketTitle, ticketType, ticketPrice }) => ({
                title: ticketTitle,
                type: "VIRTUAL",
                price: String(ticketPrice)
            }));

        if (price > 0) {
            Services.InitializeSHPayment(userId, name, cardNumber, month, year, cvv, firstName, lastName, gsmNumber, email, address, city, selectedCountry, postalCode, String(price), "TL", identityNo, formattedItems)
                .then((res) => {
                    if (res.data.status && res.data.htmlContent) {
                        setHtmlContent(res.data.htmlContent);
                        setShow3DSModal(true);
                        setPaymentID(res.data.paymentID);
                    }
                    setIsButtonDisabled(false)
                })
                .catch((err) => console.log(err));
        }

        else {
            const soldTickets = Object.values(items).flat();
            const billing = {
                tckn,
                address,
                city,
                region: selectedCountry,
                postalCode
            };

            soldTickets.forEach(ticket => {
                Services.SocialHiveCreateSoldTicket(
                    token,
                    ticket.channelID,
                    ticket.eventID,
                    ticket.ticketID,
                    "free",
                    ticket.name,
                    ticket.lastname,
                    ticket.email,
                    ticket.phone,
                    true,
                    billing
                )
                    .then(response => {
                        setActiveTab(getTranslation('details'))
                    })
                    .catch(err => {
                        console.error("CreateSoldTicket error", err);
                    });
            });
        }

    };

    const isFormValid = () => {
        return (
            name.trim() !== "" &&
            expiry.trim() !== "" &&
            cardNumber.trim() !== "" &&
            cvv.trim() !== "" &&
            phone.trim() !== "" &&
            email.trim !== "" &&
            address.trim() !== "" &&
            city.trim() !== "" &&
            selectedCountry.trim() !== "" &&
            postalCode.trim() !== "" &&
            month.trim() !== "" &&
            year.trim() !== ""
        );
    };


    return (
        <div className='payment-card-holder'>
            <div className='payment-card'>
                <div style={{ flexDirection: 'row', display: 'flex', gap: '16px' }}>
                    <div className="payment-card-input-field-container" style={{ width: '284px' }}>
                        <span className='payment-card-input-title'>Name on card *</span>
                        <input
                            className="payment-card-input-field"
                            type="text"
                            placeholder={"Name on card"}
                            value={name}
                            onChange={e => setName(e.target.value)}
                        />
                    </div>

                    <div className="payment-card-input-field-container" style={{ width: '112px' }}>
                        <span className='payment-card-input-title'>Expiry *</span>
                        <input
                            className="payment-card-input-field"
                            type="text"
                            placeholder="MM/YYYY"
                            value={expiry}
                            onChange={handleExpiryChange}
                            maxLength={7}
                        />
                    </div>
                </div>

                <div style={{ flexDirection: 'row', display: 'flex', gap: '16px', marginTop: '15px' }}>
                    <div className="payment-card-input-field-container" style={{ width: '284px' }}>
                        <span className='payment-card-input-title'>Card number *</span>
                        <input
                            className="payment-card-input-field"
                            type="text"
                            placeholder="Card number"
                            value={cardNumber}
                            maxLength={16}
                            onChange={e => setCardNumber(e.target.value)}
                        />
                    </div>

                    <div className="payment-card-input-field-container" style={{ width: '112px' }}>
                        <span className='payment-card-input-title'>CVV *</span>
                        <input
                            className="payment-card-input-field"
                            type="text"
                            placeholder="CVV"
                            value={cvv}
                            onChange={e => setCvv(e.target.value)}
                        />
                    </div>
                </div>

                <div style={{ flexDirection: 'column', display: 'flex', gap: '6px', marginTop: '15px', width: '100%' }}>
                    <span className='payment-card-input-title'>Phone *</span>
                    <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <CustomPhoneSelect options={countryCodes} onChange={setCountryCode} value={countryCode} />
                        <input
                            className="payment-card-input-field"
                            type="tel"
                            placeholder="Phone"
                            value={phone}
                            maxLength={10}
                            onChange={e => setPhone(e.target.value)}
                        />
                    </div>
                </div>

                {userCountry === "Turkey" &&
                    <div style={{ flexDirection: 'column', display: 'flex', gap: '6px', marginTop: '15px', width: '100%' }}>
                        <span className='payment-card-input-title'>T.C.K.N.</span>
                        <input
                            className="payment-card-input-field"
                            type="text"
                            placeholder="T.C.K.N."
                            value={tckn}
                            onChange={e => setTckn(e.target.value)}
                        />
                    </div>
                }


                <div style={{ flexDirection: 'column', display: 'flex', gap: '6px', marginTop: '15px', width: '100%' }}>
                    <span className='payment-card-input-title'>Email *</span>
                    <input
                        className="payment-card-input-field"
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                </div>

                <div style={{ flexDirection: 'column', display: 'flex', gap: '6px', marginTop: '15px', width: '100%' }}>
                    <span className='payment-card-input-title'>Address *</span>
                    <textarea
                        className="payment-card-input-field"
                        style={{ width: '100%', resize: 'none', fontFamily: 'Plus Jakarta Sans' }}
                        placeholder="Address"
                        value={address}
                        onChange={e => setAddress(e.target.value)}
                    ></textarea>
                </div>

                <div style={{ flexDirection: 'row', display: 'flex', gap: '9px', marginTop: '15px' }}>
                    <div className="payment-card-input-field-container" style={{ width: '202px' }}>
                        <span className='payment-card-input-title'>City *</span>
                        <input
                            className="payment-card-input-field"
                            type="text"
                            placeholder="City"
                            value={city}
                            onChange={e => setCity(e.target.value)}
                        />
                    </div>

                    <div className="payment-card-input-field-container" style={{ width: '202px' }}>
                        <span className='payment-card-input-title'>Country *</span>
                        <Dropdown
                            options={countries}
                            onChange={e => setSelectedCountry(e.target.value)}
                            value={selectedCountry}
                            placeholder={"Select country"}
                        />
                    </div>
                </div>

                <div style={{ flexDirection: 'row', display: 'flex', gap: '9px', marginTop: '15px' }}>
                    <div className="payment-card-input-field-container" style={{ width: '202px' }}>
                        <span className='payment-card-input-title'>Postal Code *</span>
                        <input
                            className="payment-card-input-field"
                            type="text"
                            placeholder="Postal Code"
                            value={postalCode}
                            onChange={e => setPostalCode(e.target.value)}
                        />
                    </div>

                    <div className="payment-card-input-field-container" style={{ width: '202px' }}>
                        <span className='payment-card-input-title'>Tax No (Optional)</span>
                        <input
                            className="payment-card-input-field"
                            type="text"
                            placeholder="Tax No"
                            value={taxNo}
                            onChange={e => setTaxNo(e.target.value)}
                        />
                    </div>
                </div>

                <div style={{ width: '100%', justifyContent: 'flex-end', display: 'flex', marginTop: '15px' }}>
                    <button
                        className="complete-payment-button"
                        onClick={handleCompletePayment}
                        disabled={!isFormValid() || isButtonDisabled}
                    >
                        Complete Payment
                    </button>

                </div>
            </div>

            <div style={{ width: '100%', justifyContent: 'center', display: 'flex', marginTop: '10px' }}>
                <img src={paymentImg} />
            </div>

            {show3DSModal && htmlContent && (
                <iframe
                    srcDoc={htmlContent}
                    title="3D Secure"
                    style={{
                        width: "100vw",
                        height: "100vh",
                        border: "none",
                        position: "absolute",
                        top: 60,
                        left: 0,
                        zIndex: 9999,
                        backgroundColor: '#fff'
                    }}
                />
            )}


        </div>
    );
}
